import DiscoverFundMeetingRequest from './DiscoverFundMeetingRequest'

export default DiscoverFundMeetingRequest
